import { createPopper } from "@popperjs/core";
import { devLog } from "../utils/_log";

class General {
  constructor() {
    this.popper();
    this.iframe();
  }

  popper() {
    try {
      const dropdown = createPopper(referenceElement, popperElement, {
        placement: placement || "bottom", // Fallback per placement
      });
    } catch (error) {
      devLog("Errore nella creazione del Popper");
    }
  }

  iframe() {
    const frame = document.getElementById("Iframe");

    if (frame) {
      console.log(frame);

      const adjustIframe = () => {
        try {
          // Controlla se l'iframe è accessibile
          const doc = frame.contentWindow.document;
          frame.style.height = doc.documentElement.scrollHeight + "px";
          frame.style.width = doc.documentElement.scrollWidth + "px";
          console.log("iframe adjusted");
        } catch (e) {
          console.error("Cross-origin issue or iframe not ready", e);
        }
      };

      frame.addEventListener("load", adjustIframe);

      // Polling per verificare quando l'iframe è pronto
      const interval = setInterval(() => {
        if (
          frame.contentWindow &&
          frame.contentWindow.document.readyState === "complete"
        ) {
          clearInterval(interval);
          adjustIframe();
        }
      }, 100);
    }
  }
}

export default General;
